import React, { useEffect, useState } from "react";
import "../assets/css/AñadirParametros.css";
import { useNavigate } from "react-router-dom";
import Layout from "./Layout";
import { getUpdateData } from "../services/API";
import socket from "../assets/js/socket";
import axios from "axios";
import alertify from "alertifyjs";
import "alertifyjs/build/css/alertify.css";
import "alertifyjs/build/css/themes/default.css";
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'react-bootstrap';
import { faPlay } from "@fortawesome/free-solid-svg-icons";

const VistaExpressLectura = () => {
    const navigate = useNavigate();
    const [modoEdicion, setModoEdicion] = useState(false);
    const [dataAdgroups, setDataAdgroups] = useState([]);
    const [dataCampaign, setDataCampaign] = useState([]);
    const [dataPortafolios, setDataPortafolios] = useState([]);
    const [dataProductos, setDataProductos] = useState([]);
    const [copiesRealTime, setCopiesRealTime] = useState({});
    const [isOpen, setIsOpen] = useState({});
    const [selectedFunction, setSelectedFunction] = useState("Select");
    const [activeSubmenuFilterLectura, setActiveSubmenuFilterLectura] = useState({ type: "ALL", value: null });
    const [submenuSearchValueLectura, setSubmenuSearchValueLectura] = useState("");
    const [checkboxes, setCheckboxes] = useState({});
    const [tituloInformacion, setTituloInformacion] = useState("");
    const [, setShowDropdown] = useState(false);
    const [showSaveModal, setShowSaveModal] = useState(false);
    const [showRevertModal, setShowRevertModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const changeDestination = (option) => {
        setSelectedFunction(option);
        setShowDropdown(false);
        setTituloInformacion(option);
        setCheckboxes({});

        setActiveSubmenuFilterLectura({ type: "ALL", value: null });
        setSubmenuSearchValueLectura("");
        const submenuInput = document.getElementById("submenuInput");
        if (submenuInput) {
            submenuInput.value = "";
        }
    };

    const toggleOpen = (itemId) => setIsOpen((prev) => ({ ...prev, [itemId]: !prev[itemId] }));

    const handleCheckboxChange = (id) => {
        setCheckboxes((prev) => {
            return {
                ...prev,
                [id]: !prev[id]
            };
        });
    };

    const handleSelectAll = () => {
        setCheckboxes((prev) => {
            const newState = { ...prev };
            if (selectedFunction === "Adgroups") {
                dataAdgroups.forEach((campaign) => {
                    campaign.adGroups.forEach((adgroup) => newState[adgroup.adGroupId] = true);
                });
            }
            else if (selectedFunction === "Campaigns") {
                dataCampaign.forEach((campaign) => {
                    newState[campaign.campaignId] = true;
                });
            }
            else if (selectedFunction === "Portafolios") {
                dataPortafolios.forEach((portafolio) => {
                    newState[portafolio.portfolioId] = true;
                });
            }
            else if (selectedFunction === "Asins") {
                dataProductos.forEach((producto) => {
                    newState[producto.adId] = true;
                });
            }
            return newState;
        });
    };

    const handleClearAll = () => {
        setCheckboxes((prev) => {
            const newState = { ...prev };
            if (selectedFunction === "Adgroups") {
                dataAdgroups.forEach((campaign) => {
                    campaign.adGroups.forEach((adgroup) => newState[adgroup.adGroupId] = false);
                });
            }
            else if (selectedFunction === "Campaigns") {
                dataCampaign.forEach((campaign) => {
                    newState[campaign.campaignId] = false;
                });
            }
            else if (selectedFunction === "Portafolios") {
                dataPortafolios.forEach((portafolio) => {
                    newState[portafolio.portfolioId] = false;
                });
            }
            else if (selectedFunction === "Asins") {
                dataProductos.forEach((producto) => {
                    newState[producto.adId] = false;
                });
            }
            return newState;
        });
    };

    const handleFilterClick = (filtro) => {
        if (filtro === "ALL") {
            setActiveSubmenuFilterLectura({ type: "ALL", value: null });
        } else if (filtro === "ENABLED" || filtro === "PAUSED") {
            setActiveSubmenuFilterLectura({ type: "STATE", value: filtro });
        }
    };

    const getDataRealTime = (response) => {
        const campaigns = response.data.campaigns.map(campaign => ({
            ...campaign,
            adGroups: campaign.adGroups.filter(group => group.state !== "ARCHIVED")
        }))
            .filter(campaign => campaign.adGroups.length > 0);

        const productos = response.data.productos.map(producto => ({
            ...producto,
            campaigns: producto.campaigns.filter(campaign => campaign.state !== "ARCHIVED")
        }))
            .filter(producto => producto.campaigns.length > 0 && producto.state !== "ARCHIVED")

        const portafolios = response.data.portfolios.map(portafolio => ({
            ...portafolio,
            campaigns: portafolio.campaigns.filter(campaign => campaign.state !== "ARCHIVED")
        }))
            .filter(portafolio => portafolio.campaigns.length > 0 && portafolio.state !== "ARCHIVED")

        setDataAdgroups(campaigns);
        setDataProductos(productos);
        setDataCampaign(campaigns);
        setDataPortafolios(portafolios);
        setCopiesRealTime({
            adgroups: campaigns,
            campaigns: campaigns,
            portafolios: portafolios,
            productos: productos
        });
    }

    useEffect(() => {
        (async () => {
            const accountID = localStorage.getItem("selectedAccountValue");
            const response = await getUpdateData(accountID);
            getDataRealTime(response);
        })();
    }, [setDataAdgroups, setDataCampaign, setDataPortafolios, setCopiesRealTime, setDataProductos]);

    const notifyBOT = async () => {
        await axios.get("https://bot.jungleclick.online");
        console.log("BOT notificado.");
    }

    const cargarDatos = (data) => {
        const destinationMap = {
            1: "Adgroups",
            2: "Campaigns",
            3: "Portafolios",
            4: "Asins"
        };

        const parsed = JSON.parse(data);
        if (parsed && parsed.length > 0) {
            const destinationText = destinationMap[parsed[0].destination_id];
            setSelectedFunction(destinationText);

            const nuevosChecks = {};
            const destinos = JSON.parse(parsed[0].destinations);

            if (parsed[0].destination_id === 1) {
                destinos.campaigns.forEach(camp => {
                    camp.adGroups.forEach(ad => {
                        nuevosChecks[ad.adGroupId] = true;
                    });
                });
            } else if (parsed[0].destination_id === 2) {
                destinos.campaigns.forEach(camp => {
                    nuevosChecks[camp.campaignId] = true;
                });
            } else if (parsed[0].destination_id === 3) {
                destinos.portfolios.forEach(port => {
                    nuevosChecks[port.portfolioId] = true;
                });
            } else if (parsed[0].destination_id === 4) {
                destinos.asins.forEach(prod => {
                    nuevosChecks[prod.asin] = true;
                });
            }
            setCheckboxes(nuevosChecks);
        }
    };

    useEffect(() => {
        const handleConnect = () => {
            console.log("✅ Conectado al servidor WebSocket:", socket.id);
            notifyBOT();
        };

        const handleUpdate = (data) => {
            console.log("🔄 Actualización recibida:", data);
            const account = localStorage.getItem("selectedAccountValue")
            if (data.data.accountId == account)
                getDataRealTime(data.data.data);
            else
                console.log("Actualización omitida");
        };

        socket.on("connect", handleConnect);
        socket.on("update", handleUpdate);

        return () => {
            socket.off("connect", handleConnect);
            socket.off("update", handleUpdate);
        };
    }, []);

    const [editableGroupData, setEditableGroupData] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const result = localStorage.getItem("expressGroupData");
            if (result) {
                cargarDatos(result);
                const parsedData = JSON.parse(result);
                const formattedData = parsedData.map(group => ({
                    ...group,
                    created_at: format(new Date(group.created_at), 'yyyy-MM-dd HH:mm:ss', { locale: es }),
                    updated_at: format(new Date(group.updated_at), 'yyyy-MM-dd HH:mm:ss', { locale: es }),
                    negative_type: group.negative_type_id === 1 ? 'Negative Exact' : 'Negative Phrase',
                    destination: {
                        1: "Adgroups",
                        2: "Campaigns",
                        3: "Portafolios",
                        4: "Asins"
                    }[group.destination_id] || "No definido"
                }));
                setEditableGroupData(formattedData);
            }
        };
        fetchData();
    }, []);

    const handleInputChange = (index, field, value) => {
        const newData = [...editableGroupData];
        newData[index][field] = value;
        setEditableGroupData(newData);
    };

    const handleEliminarFila = (index) => {
        const newData = [...editableGroupData];
        newData.splice(index, 1);
        setEditableGroupData(newData);
    };

    const handleFunctionSelect = (option) => {
        if (selectedFunction === "Select" || selectedFunction.trim() === "")
            changeDestination(option);
        else
            alertify.confirm("Cambio de destino", "Se perderan los checkbox del destino actual, desea continuar?", () => {
                changeDestination(option);
            }, () => alertify.error("Operación cancelada"));
    };

    const handleEditar = () => setModoEdicion(!modoEdicion);

    useEffect(() => {
        if (!copiesRealTime || Object.keys(copiesRealTime).length === 0 || !selectedFunction || selectedFunction === "Select" || selectedFunction === "") {
            setDataAdgroups([]);
            setDataCampaign([]);
            setDataPortafolios([]);
            setDataProductos([]);
            return;
        }

        let baseDataForPanel;
        switch (selectedFunction) {
            case "Adgroups":
                baseDataForPanel = copiesRealTime.adgroups ? [...copiesRealTime.adgroups] : [];
                break;
            case "Campaigns":
                baseDataForPanel = copiesRealTime.campaigns ? [...copiesRealTime.campaigns] : [];
                break;
            case "Portafolios":
                baseDataForPanel = copiesRealTime.portafolios ? [...copiesRealTime.portafolios] : [];
                break;
            case "Asins":
                baseDataForPanel = copiesRealTime.productos ? [...copiesRealTime.productos] : [];
                break;
            default:
                baseDataForPanel = [];
        }

        let filteredByDropdown = baseDataForPanel;

        if (activeSubmenuFilterLectura.type === "STATE") {
            const filterStateValue = activeSubmenuFilterLectura.value;
            if (selectedFunction === "Adgroups") {
                filteredByDropdown = baseDataForPanel.map(campaign => ({
                    ...campaign,
                    adGroups: campaign.adGroups.filter(adgroup => adgroup.state === filterStateValue)
                })).filter(campaign => campaign.adGroups.length > 0);
            } else if (selectedFunction === "Campaigns" || selectedFunction === "Portafolios") {
                filteredByDropdown = baseDataForPanel.filter(item => item.state === filterStateValue);
            } else if (selectedFunction === "Asins") {
                if (activeSubmenuFilterLectura.value) {
                    alertify.notify("Los Asins no tienen un filtro de estado ENABLED o PAUSED directo en esta vista.", "warning", 5);
                }
            }
        }

        let finalFilteredDataForPanel = filteredByDropdown;

        if (submenuSearchValueLectura.trim() !== "") {
            const searchTermLower = submenuSearchValueLectura.toLowerCase();
            const matchesSearch = (name) => String(name || "").toLowerCase().includes(searchTermLower);

            if (selectedFunction === "Adgroups") {
                finalFilteredDataForPanel = filteredByDropdown.map(campaign => ({
                    ...campaign,
                    adGroups: campaign.adGroups.filter(adgroup => matchesSearch(adgroup.name))
                })).filter(campaign => campaign.adGroups.length > 0);
            } else if (selectedFunction === "Campaigns") {
                finalFilteredDataForPanel = filteredByDropdown.filter(campaign => matchesSearch(campaign.name));
            } else if (selectedFunction === "Portafolios") {
                finalFilteredDataForPanel = filteredByDropdown.filter(portafolio => matchesSearch(portafolio.name || "Sin Portafolio"));
            } else if (selectedFunction === "Asins") {
                finalFilteredDataForPanel = filteredByDropdown.filter(asin => matchesSearch(asin.asin || "Sin Asin"));
            }
        }

        switch (selectedFunction) {
            case "Adgroups":
                setDataAdgroups(finalFilteredDataForPanel);
                break;
            case "Campaigns":
                setDataCampaign(finalFilteredDataForPanel);
                break;
            case "Portafolios":
                setDataPortafolios(finalFilteredDataForPanel);
                break;
            case "Asins":
                setDataProductos(finalFilteredDataForPanel);
                break;
            default:
                setDataAdgroups([]);
                setDataCampaign([]);
                setDataPortafolios([]);
                setDataProductos([]);
        }

    }, [copiesRealTime, selectedFunction, activeSubmenuFilterLectura, submenuSearchValueLectura]);

    return (
        <Layout>
            <div className="contenedor-principal">
                <main className="container-fluid bg-white">
                    <div className="row">
                        <div className="col-7 px-3 py-3 bg-white border border-2 border-dark">
                            <div className="mt-5 d-flex justify-content-center align-items-center flex-column">
                                <h2 className="text-center mx-1">Vista de términos negativizados</h2>
                                <div className="d-flex justify-content-end my-3">
                                    {!modoEdicion && (
                                        <>
                                            <button className="btn btn-primary mx-2" onClick={handleEditar}>
                                                Activar edición
                                            </button>
                                            <button className="btn btn-danger mx-2" onClick={() => navigate("/ListaExpress")}>
                                                Volver a la lista
                                            </button>
                                        </>
                                    )}
                                    {modoEdicion && (
                                        <>
                                            <button
                                                className="btn btn-success mx-2"
                                                onClick={() => setShowSaveModal(true)}
                                            >
                                                Guardar cambios
                                            </button>
                                            <button
                                                className="btn btn-warning mx-2"
                                                onClick={() => setShowRevertModal(true)}
                                            >
                                                Deshacer cambios
                                            </button>
                                            <button
                                                className="btn btn-danger mx-2"
                                                onClick={() => setShowDeleteModal(true)}
                                            >
                                                Eliminar parámetro
                                            </button>
                                        </>
                                    )}

                                </div>
                            </div>
                            <div className="filtros-superiores">
                                <div className="grupo-filtro1 mx-2 flex-column">
                                    <label className="mt-2 fs-5" htmlFor="destination-select">Destino:</label>
                                    <select
                                        id="destination-select"
                                        className="form-select"
                                        disabled={!modoEdicion}
                                        value={selectedFunction}
                                        onChange={(e) => { handleFunctionSelect(e.target.value) }}
                                    >
                                        <option value="">Seleccione una opción</option>
                                        <option value="Adgroups">Adgroups</option>
                                        <option value="Campaigns">Campaigns</option>
                                        <option value="Portafolios">Portafolios</option>
                                        <option value="Asins">Asins</option>
                                    </select>
                                </div>
                            </div>
                            <div className="d-flex">
                                <div className="w-100 p-3">
                                    <h3 className="my-3 mb-5">Editar Términos</h3>
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>CST</th>
                                                <th>Negative Type</th>
                                                <th>Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {editableGroupData.map((item, index) => (
                                                <tr key={index}>
                                                    <td >
                                                        <input
                                                            type="text"
                                                            disabled={!modoEdicion}
                                                            className="form-control"
                                                            value={item.keyword}
                                                            onChange={(e) => handleInputChange(index, 'keyword', e.target.value)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <select
                                                            className="form-control my-0"
                                                            disabled={!modoEdicion}
                                                            value={item.negative_type === 'Negative Exact' ? 'Negative Exact' : 'Negative Phrase'}
                                                            onChange={(e) => handleInputChange(index, 'negative_type', e.target.value)}
                                                        >
                                                            <option>Negative Exact</option>
                                                            <option>Negative Phrase</option>
                                                        </select>
                                                    </td>
                                                    <td className="text-center">
                                                        <Button
                                                            variant="danger"
                                                            size="sm"
                                                            disabled={!modoEdicion}
                                                            onClick={() => handleEliminarFila(index)}
                                                        >
                                                            <FontAwesomeIcon icon={faTrash} /> Eliminar
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="col-5 px-3 py-3 bg-white border border-2 border-dark">
                            <div className="row">
                                <div className="col-6">
                                    <input
                                        id="submenuInput"
                                        type="text"
                                        className="form-control w-100"
                                        placeholder="Buscar..."
                                        value={submenuSearchValueLectura}
                                        onChange={(e) => setSubmenuSearchValueLectura(e.target.value)}
                                    />

                                </div>
                                <div className="col-6">
                                    <div className="dropdown w-auto">
                                        <button className="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            Filtrar por
                                        </button>
                                        <ul className="dropdown-menu">
                                            <li style={{ cursor: "pointer", margin: "5px" }} onClick={() => handleFilterClick("ENABLED")}>State Enabled</li>
                                            <li style={{ cursor: "pointer", margin: "5px" }} onClick={() => handleFilterClick("PAUSED")}>State Paused</li>
                                            <li style={{ cursor: "pointer", margin: "5px" }} onClick={() => handleFilterClick("ALL")}>Sin Filtro</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <h3 className="my-3">{tituloInformacion}</h3>
                            {selectedFunction !== "Select" && (
                                <div className="checkbox-actions1">
                                    <button
                                        className="btn btn-secondary mx-2 my-2"
                                        onClick={handleSelectAll}
                                        disabled={!modoEdicion}
                                    >
                                        Seleccionar todo
                                    </button>
                                    <button
                                        className="btn btn-danger mx-2 my-2"
                                        onClick={handleClearAll}
                                        disabled={!modoEdicion}
                                    >
                                        Limpiar todo
                                    </button>
                                </div>
                            )}

                            {(selectedFunction === "Adgroups" ? dataAdgroups : [])
                                .map((campaign, idx) => (
                                    <div className="campaign-container" style={{ overflow: "auto", height: "300px", }} key={idx}>
                                        <button className="btn btn-success w-100 text-center d-flex justify-content-evenly align-items-center" onClick={() => toggleOpen(campaign.campaignId)}
                                        >
                                            <span className="float-start">
                                                {isOpen[campaign.campaignId]
                                                    ? "▼ "
                                                    : <FontAwesomeIcon className="me-2" icon={faPlay} />}
                                                Campaña: {campaign.name.replaceAll("_", " ")}
                                            </span>
                                            <span className="float-end text-light" style={{ fontSize: "11px", textTransform: "uppercase" }}>
                                                State: {campaign.state} <br />
                                                Type: {campaign.type}
                                            </span>

                                        </button>
                                        {isOpen[campaign.campaignId] && (
                                            <div className="adgroup-options">
                                                {campaign.adGroups.map((adgroup, index) => (
                                                    <div key={`adgroup-${adgroup.adGroupId}-${index}`}
                                                        className="form-control d-flex align-items-center justify-content-evenly">
                                                        <input type="checkbox" className="mx-3" disabled={!modoEdicion} checked={
                                                            checkboxes?.[adgroup.adGroupId] || false} onChange={() =>
                                                                handleCheckboxChange(adgroup.adGroupId)}
                                                            id={`adgroup-${campaign.campaignId}-${adgroup.adGroupId}-${index}`}
                                                        />
                                                        <label style={{ fontSize: "14px" }} htmlFor={`adgroup-${campaign.campaignId}-${adgroup.adGroupId}-${index}`}>
                                                            AdGroup: {adgroup.name.replaceAll("_", " ")}
                                                        </label>
                                                        <span className="float-end" style={{ fontSize: "11px", textTransform: "uppercase" }}>Status: {adgroup.state}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                )
                                )}

                            {(selectedFunction === "Campaigns" ? dataCampaign : [])
                                .map((campaign, idx) => (
                                    <div className="campaign-container" style={{ overflow: "auto", height: "300px", }} key={idx}>

                                        <div className="row px-0 mx-0">
                                            <div className="col-1 px-0 d-flex justify-content-center align-items-center">
                                                <input
                                                    type="checkbox"
                                                    disabled={!modoEdicion}
                                                    checked={checkboxes?.[campaign.campaignId] || false}
                                                    onChange={() => handleCheckboxChange(campaign.campaignId)}
                                                    className="form-check-input h-50 w-100 border border-1 border-dark"
                                                />
                                            </div>
                                            <div className="col-11">
                                                <button className="btn btn-success w-100 text-center d-flex justify-content-evenly align-items-center" onClick={() => toggleOpen(campaign.campaignId)}
                                                >
                                                    <span className="float-start">
                                                        {isOpen[campaign.campaignId]
                                                            ? "▼ "
                                                            : <FontAwesomeIcon className="me-2" icon={faPlay} />}
                                                        Campaña: {campaign.name.replaceAll("_", " ")}
                                                    </span>
                                                    <span className="float-end text-light" style={{ fontSize: "11px", textTransform: "uppercase" }}>
                                                        State: {campaign.state} <br />
                                                        Type: {campaign.type}
                                                    </span>

                                                </button>
                                            </div>
                                            <div className="col-12">
                                                {isOpen[campaign.campaignId] && (
                                                    <div className="adgroup-options">
                                                        {campaign.adGroups.map((adgroup, index) => (
                                                            <div key={`adgroup-${adgroup.adGroupId}-${index}`}
                                                                className="form-control d-flex align-items-center justify-content-evenly">
                                                                <label style={{ fontSize: "14px" }}>
                                                                    AdGroup: {adgroup.name.replaceAll("_", " ")}
                                                                </label>
                                                                <span className="float-end" style={{ fontSize: "11px", textTransform: "uppercase" }}>Status: {adgroup.state}</span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )
                                )}

                            {(selectedFunction === "Portafolios" ? dataPortafolios : [])
                                .map((portafolio, idx) => (
                                    <div className="campaign-container" style={{ overflow: "auto", height: "300px", }} key={idx}>
                                        <div className="row px-0 mx-0">
                                            <div className="col-1 px-0 d-flex justify-content-center align-items-center">
                                                <input
                                                    disabled={!modoEdicion}
                                                    type="checkbox"
                                                    checked={checkboxes?.[portafolio.portfolioId] || false}
                                                    onChange={() => handleCheckboxChange(portafolio.portfolioId)}
                                                    className="form-check-input h-50 w-100 border border-1 border-dark"
                                                />
                                            </div>
                                            <div className="col-11">
                                                <button className="btn btn-success w-100 text-center d-flex justify-content-evenly align-items-center" onClick={() => toggleOpen(portafolio.portfolioId)}
                                                >
                                                    <span className="float-start">
                                                        {isOpen[portafolio.portfolioId]
                                                            ? "▼ "
                                                            : <FontAwesomeIcon className="me-2" icon={faPlay} />}
                                                        Portafolio: {portafolio.name.replaceAll("_", " ")}
                                                    </span>
                                                    <span className="float-end text-light" style={{ fontSize: "11px", textTransform: "uppercase" }}>
                                                        State: {portafolio.state} <br />
                                                    </span>
                                                </button>
                                            </div>
                                            <div className="col-12">
                                                {isOpen[portafolio.portfolioId] && (
                                                    <div className="adgroup-options">
                                                        {portafolio.campaigns.map((campaign, index) => (
                                                            <div key={`campaign-${campaign.campaignId}-${index}`}
                                                                className="form-control d-flex align-items-center justify-content-evenly">
                                                                <label style={{ fontSize: "14px" }}>
                                                                    Campaña: {campaign.name.replaceAll("_", " ")}
                                                                </label>
                                                                <span className="float-end" style={{ fontSize: "11px", textTransform: "uppercase" }}>
                                                                    Status: {campaign.state}<br />
                                                                    Type: {campaign.type}
                                                                </span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )
                                )}

                            {(selectedFunction === "Asins" ? dataProductos : [])
                                .map((producto, idx) => (
                                    <div className="campaign-container" style={{ overflow: "auto", height: "300px", }} key={idx}>

                                        <div className="row px-0 mx-0">
                                            <div className="col-1 px-0 d-flex justify-content-center align-items-center">
                                                <input
                                                    disabled={!modoEdicion}
                                                    type="checkbox"
                                                    checked={checkboxes?.[producto.adId] || false}
                                                    onChange={() => handleCheckboxChange(producto.adId)}
                                                    className="form-check-input h-50 w-100 border border-1 border-dark"
                                                />
                                            </div>
                                            <div className="col-11">
                                                <button className="btn btn-success w-100 text-center d-flex justify-content-evenly align-items-center" onClick={() => toggleOpen(producto.adId)}
                                                >
                                                    <span className="float-start">
                                                        {isOpen[producto.adId]
                                                            ? "▼ "
                                                            : <FontAwesomeIcon className="me-2" icon={faPlay} />}
                                                        ASIN: {producto.asin.replaceAll("_", " ") || "ASIN sin nombre"}
                                                    </span>
                                                </button>
                                            </div>
                                            <div className="col-12">
                                                {isOpen[producto.adId] && (
                                                    <div className="adgroup-options">
                                                        {producto.campaigns.map((campaign, index) => (
                                                            <div key={`campaign-${campaign.campaignId}-${index}`}
                                                                className="form-control d-flex align-items-center justify-content-evenly">
                                                                <label style={{ fontSize: "14px" }}>
                                                                    Campaña: {campaign.name.replaceAll("_", " ")}
                                                                </label>
                                                                <span className="float-end" style={{ fontSize: "11px", textTransform: "uppercase" }}>
                                                                    Status: {campaign.state}<br />
                                                                    Type: {campaign.type}
                                                                </span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )
                                )}

                        </div>
                    </div>
                </main>
                {showSaveModal && (
                    <div className="modal1-overlay">
                        <div className="modal1">
                            <label className="fs-4 text-center my-3">¿Deseas guardar los cambios?</label>
                            <div className="modal1-buttons">
                                <button className="btn btn-success" onClick={() => { }}>
                                    Sí, guardar
                                </button>
                                <button
                                    className="btn btn-danger"
                                    onClick={() => setShowSaveModal(false)}
                                >
                                    No, cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                {showRevertModal && (
                    <div className="modal1-overlay">
                        <div className="modal1">
                            <label className="fs-4 text-center my-3">
                                ¿Estás seguro de que deseas deshacer los cambios?
                            </label>
                            <div className="modal1-buttons">
                                <button className="btn btn-success" onClick={() => { }}>
                                    Sí, deshacer
                                </button>
                                <button
                                    className="btn btn-danger"
                                    onClick={() => setShowRevertModal(false)}
                                >
                                    No, cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                {showDeleteModal && (
                    <div className="modal1-overlay">
                        <div className="modal1">
                            <label className="fs-4 text-center my-3">
                                ¿Estás seguro de que deseas eliminar este parámetro?
                            </label>
                            <div className="modal1-buttons">
                                <button className="btn btn-success" onClick={() => { }}>
                                    Sí, eliminar
                                </button>
                                <button
                                    className="btn btn-danger"
                                    onClick={() => setShowDeleteModal(false)}
                                >
                                    No, cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </Layout>
    );
};

export default VistaExpressLectura;